module.exports = __webpack_public_path__ + "img/5.5572e8f9.png";